(function() {
    /** @ngInject */
    function amountsPageController($scope, $state,$http){
        $scope.amounts   = $scope.booking.getAmountsList();
        $scope.custom_request_modal = false;
        $scope.custom_seating = false;
        $scope.max_seating = settings.max_seating;
        $scope.max_people = settings.max_people;
        $scope.max_seating_available = (settings.custom_request && settings.custom_request == true) || (settings.max_seating > 0);
        var amt = _.max($scope.amounts);
        if($scope.max_seating_available) {
            if ($scope.max_seating === amt) {
                $scope.max_people = amt;
                $scope.max_seating = amt;
                if(_.size($scope.amounts) === 1){
                    $scope.amounts = [];
                }else {
                    $scope.amounts = _.dropRight($scope.amounts);
                }
            } else if ($scope.max_seating < amt) {
                $scope.max_seating = amt + 1;
                $scope.max_people = amt;
            } else if ($scope.max_seating > amt + 1) {
                $scope.max_seating = amt + 1;
                $scope.max_people = amt;
            }
        }
        updateWidgetStep('Guests',{meal : $scope.booking.meal.name,mealId : $scope.booking.meal.id, averageValue : $scope.booking.meal.avg_gtm_price});
        $scope.custom_request_data = {
            firstname : '',
            lastname : '',
            email : '',
            phone : '',
            amount : $scope.max_people+1,
            date :'',
            comment : ''
        };
        $scope.haveGroup = function(){
            return _.has($scope.booking.meal,'group_booking') && _.size($scope.booking.meal.group_booking) > 0 ? $scope.booking.meal.group_booking : false;
        };

        $scope.selectAmount = function(amount){
            //updateWidgetStep('Guests','amount', amount);
            $scope.booking.blocked_amounts = [];
            if(_.parseInt($scope.max_seating) > 0 && amount >= ($scope.max_seating)){
                $scope.custom_seating = true;
                if(settings.custom_request && settings.custom_request == true){
                    //$scope.openCustomRequest();
                    $scope.booking.custom_request = true;
                    $scope.booking.amount = amount;
                    $scope.goTo('guest-details');
                }
                return false;
            }


            $scope.booking.amount = amount;
            if(typeof(dataLayer) !== 'undefined'){ dataLayer.push({'event': 'waiterAidMessage' , 'message' : {'step' : 'Choose-amount'}}); }
            var dates = [];
            _.forEach($scope.booking.meal.calendar, function (i, k) {
                if (i === 1)
                    dates.push(k);
            });
            if(_.size(dates) >= 1 && settings.allow_full_seated_meals == 'Y') {
                $http.post("/booking-widget/api/getOffDays", {
                    from: _.head(dates),
                    to: _.last(dates),
                    date: _.head(dates),
                    amount: $scope.booking.amount,
                    mealid: $scope.booking.mealid,
                    hash: hash
                }).success(function (response) {
                    if (_.has(response, 'dates') && _.size(response.dates) > 0) {
                        $scope.booking.blocked_amounts = response.dates;
                    }
                    $scope.goTo('calendar');
                });
            }else{
                $scope.goTo('calendar');
            }
            $scope.goTo('calendar');
        };
    }
    angular.module("Waiteraid").controller("amountCtrl", amountsPageController);
})();
